import { useQuery } from "@tanstack/react-query";
import { getProfileData } from "../services/firebase";
import { getGuestProfile } from "../services/guestStorage";

export const useProfile = (uid) => {
  const isGuest = !uid || uid === "guest";

  return useQuery({
    queryKey: ["profile", uid],
    queryFn: () => (isGuest ? getGuestProfile() : getProfileData(uid)),
    enabled: true,
    staleTime: isGuest ? 0 : 1000 * 60 * 5,
  });
};
